import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const homePurple = svgToTinyDataUri(
  `<svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="home">
<mask id="mask0_0_34" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
<rect id="Bounding box" width="32" height="32" fill="var(--fill-0, #D9D9D9)"/>
</mask>
<g mask="url(#mask0_0_34)">
<path id="home_2" d="M8 25.3333H12V17.3333H20V25.3333H24V13.3333L16 7.33333L8 13.3333V25.3333ZM5.33333 28V12L16 4L26.6667 12V28H17.3333V20H14.6667V28H5.33333Z" fill="var(--fill-0, #501283)"/>
</g>
</g>
</svg>`
);
